export default "__VITE_ASSET__DvPgBjs9__"